import { GridColTypeDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Box, Tooltip, useTheme } from "@mui/material";

import baseColumn from "./BaseColumn";

export interface ColorBoxOptions {
  headerLabels?: Record<string, string>;
}

export default function colorBoxColumn(options?: ColorBoxOptions): GridColTypeDef {
  const colorBoxColumn: GridColTypeDef = {
    ...baseColumn,
    type: "custom",
    renderCell: (params: GridRenderCellParams) => {
      const theme = useTheme();
      const chartColorArray = theme.colors.namedColors.chartColorArray;

      // Use gray when no cluster
      const boxColor = params.value
        ? chartColorArray[(params.value < 1 ? params.value : params.value - 1) % chartColorArray.length]
        : theme.palette.grey[400];

      return (
        <Tooltip title={params.value}>
          <Box
            sx={{
              height: "100%",
              width: "100%",
              paddingTop: 1,
              paddingBottom: 1
            }}>
            <Box
              sx={{
                height: "100%",
                width: "35px",
                bgcolor: boxColor
              }} />
          </Box>
        </Tooltip>
      );
    }
  };

  return colorBoxColumn;
}
